module.exports = __webpack_public_path__ + "static/media/01.ac92a0eb.webp";